"use client";
import { Box, Flex, Grid, GridItem, Heading, Link } from "@chakra-ui/react";
import { SectionTemplate } from "components/individuals/blocks";
import { ImageFragment } from "lib/gcms/gcms-typings";
import { ThemeColor } from "lib/gcms/theme-color";
import Image from "next/image";

interface Partner {
  logo: ImageFragment & { alt?: string };
  url: string;
  name: string;
}
interface PartnershipsBannerProps {
  bg: ThemeColor;
  title: string;
  partners: Partner[];
}

export default function ClientPartnershipsBanner(
  props: PartnershipsBannerProps,
) {
  const needSpace = props.partners.length % 2 === 0;
  const lastRow = needSpace ? props.partners.slice(-2) : [];
  const frontRows = needSpace ? props.partners.slice(0, -2) : props.partners;
  return (
    <SectionTemplate textAlign={"center"} bg={props.bg}>
      <Heading size={"md"} fontWeight={"bold"}>
        {props.title}
      </Heading>
      <Grid
        mt={16}
        templateColumns={{
          md: "repeat(2, 1fr)",
          lg: "repeat(3, 1fr)",
        }}
        justifyItems={"center"}
        alignItems={"center"}
        gap={{
          base: 12,
          lg: 16,
        }}
        mx={"auto"}
      >
        {frontRows.map((partner, idx) => (
          <LogoGridItem {...partner} key={`partnerships-grid-item-${idx}`} />
        ))}

        {needSpace ? (
          <>
            <LogoGridItem {...lastRow[0]} />

            <GridItem
              display={{
                base: "none",
                lg: "block",
              }}
            >
              <Box visibility={"hidden"} />
            </GridItem>

            <LogoGridItem {...lastRow[1]} />
          </>
        ) : (
          <></>
        )}
      </Grid>
    </SectionTemplate>
  );
}

const LogoGridItem = (props: Partner) => {
  return (
    <>
      <GridItem
        h={{
          md: "110px",
        }}
      >
        {props.url ? (
          <Flex h={"full"} alignItems={"center"}>
            <Link href={props.url} target="_blank">
              <Image
                src={props?.logo?.url as string}
                alt={props?.logo?.alt as string}
                width={
                  props?.name === "NSF iCorps" || props?.name === "Element46"
                    ? 280
                    : 220
                }
                height={
                  props?.name === "NSF iCorps" || props?.name === "Element46"
                    ? 280
                    : 220
                }
                placeholder={
                  typeof props?.logo?.blurDataURL === "string"
                    ? "blur"
                    : undefined
                }
                blurDataURL={
                  typeof props?.logo.blurDataURL === "string"
                    ? props?.logo?.blurDataURL
                    : undefined
                }
              />
            </Link>
          </Flex>
        ) : (
          <Flex h={"full"} alignItems={"center"}>
            <Image
              src={props?.logo?.url as string}
              alt={props?.logo?.alt as string}
              width={props?.name === "Foundation House" ? 130 : 220}
              height={props?.name === "Foundation House" ? 130 : 220}
              placeholder={
                typeof props?.logo?.blurDataURL === "string"
                  ? "blur"
                  : undefined
              }
              blurDataURL={
                typeof props?.logo.blurDataURL === "string"
                  ? props?.logo?.blurDataURL
                  : undefined
              }
            />
          </Flex>
        )}
      </GridItem>
    </>
  );
};
